export * from '@primeuix/themes/material/skeleton';
export { default } from '@primeuix/themes/material/skeleton';
